/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as authPagesRouteRouteImport } from './routes/(auth-pages)/route'
import { Route as authenticatedRouteRouteImport } from './routes/(authenticated)/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as authPagesAanmeldenRouteImport } from './routes/(auth-pages)/aanmelden'
import { Route as authPagesAanmeldenPartnerRouteImport } from './routes/(auth-pages)/aanmelden-partner'
import { Route as authPagesInloggenRouteImport } from './routes/(auth-pages)/inloggen'
import { Route as authPagesOnboardingRouteRouteImport } from './routes/(auth-pages)/onboarding/route'
import { Route as authPagesVerifierenRouteImport } from './routes/(auth-pages)/verifieren'
import { Route as authenticatedAppRouteRouteImport } from './routes/(authenticated)/_app/route'
import { Route as authenticatedBetalingInstellenRouteRouteImport } from './routes/(authenticated)/betaling-instellen/route'
import { Route as authenticatedEnergiefactuurUploadenRouteRouteImport } from './routes/(authenticated)/energiefactuur-uploaden/route'
import { Route as authenticatedLaadpaalFotosUploadenRouteRouteImport } from './routes/(authenticated)/laadpaal-fotos-uploaden/route'
import { Route as authenticatedUitbetalingInstellenRouteRouteImport } from './routes/(authenticated)/uitbetaling-instellen/route'
import { Route as authenticatedUploadLaadsessiesRouteRouteImport } from './routes/(authenticated)/upload-laadsessies/route'
import { Route as authenticatedVerbindAccountRouteRouteImport } from './routes/(authenticated)/verbind-account/route'
import { Route as publicAccountInactiefRouteImport } from './routes/(public)/account-inactief'
import { Route as publicActievoorwaardenRouteImport } from './routes/(public)/actievoorwaarden'
import { Route as publicCookiesRouteImport } from './routes/(public)/cookies'
import { Route as publicMachtigingOndertekenenRouteImport } from './routes/(public)/machtiging-ondertekenen'
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy'
import { Route as publicTermsRouteImport } from './routes/(public)/terms'
import { Route as authPagesOnboardingIndexRouteImport } from './routes/(auth-pages)/onboarding/index'
import { Route as authPagesOnboardingStepRouteImport } from './routes/(auth-pages)/onboarding/$step'
import { Route as authenticatedBetalingInstellenIndexRouteImport } from './routes/(authenticated)/betaling-instellen/index'
import { Route as authenticatedBetalingInstellenStepRouteImport } from './routes/(authenticated)/betaling-instellen/$step'
import { Route as authenticatedEnergiefactuurUploadenIndexRouteImport } from './routes/(authenticated)/energiefactuur-uploaden/index'
import { Route as authenticatedLaadpaalFotosUploadenIndexRouteImport } from './routes/(authenticated)/laadpaal-fotos-uploaden/index'
import { Route as authenticatedUitbetalingInstellenIndexRouteImport } from './routes/(authenticated)/uitbetaling-instellen/index'
import { Route as authenticatedUploadLaadsessiesIndexRouteImport } from './routes/(authenticated)/upload-laadsessies/index'
import { Route as authenticatedVerbindAccountIndexRouteImport } from './routes/(authenticated)/verbind-account/index'
import { Route as publicLaadpaalLocatieTokenRouteImport } from './routes/(public)/laadpaal-locatie/$token'
import { Route as authenticatedAppDashboardIndexRouteImport } from './routes/(authenticated)/_app/dashboard/index'
import { Route as authenticatedAppMijnGegevensIndexRouteImport } from './routes/(authenticated)/_app/mijn-gegevens/index'
import { Route as authenticatedAppMijnLaadpaalIndexRouteImport } from './routes/(authenticated)/_app/mijn-laadpaal/index'
import { Route as authenticatedAppVriendenvoordeelIndexRouteImport } from './routes/(authenticated)/_app/vriendenvoordeel/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const authPagesRouteRoute = authPagesRouteRouteImport.update({
  id: '/(auth-pages)',
  getParentRoute: () => rootRouteImport,
} as any)
const authenticatedRouteRoute = authenticatedRouteRouteImport.update({
  id: '/(authenticated)',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const authPagesAanmeldenRoute = authPagesAanmeldenRouteImport.update({
  id: '/aanmelden',
  path: '/aanmelden',
  getParentRoute: () => authPagesRouteRoute,
} as any)
const authPagesAanmeldenPartnerRoute =
  authPagesAanmeldenPartnerRouteImport.update({
    id: '/aanmelden-partner',
    path: '/aanmelden-partner',
    getParentRoute: () => authPagesRouteRoute,
  } as any)
const authPagesInloggenRoute = authPagesInloggenRouteImport.update({
  id: '/inloggen',
  path: '/inloggen',
  getParentRoute: () => authPagesRouteRoute,
} as any)
const authPagesOnboardingRouteRoute =
  authPagesOnboardingRouteRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => authPagesRouteRoute,
  } as any)
const authPagesVerifierenRoute = authPagesVerifierenRouteImport.update({
  id: '/verifieren',
  path: '/verifieren',
  getParentRoute: () => authPagesRouteRoute,
} as any)
const authenticatedAppRouteRoute = authenticatedAppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => authenticatedRouteRoute,
} as any)
const authenticatedBetalingInstellenRouteRoute =
  authenticatedBetalingInstellenRouteRouteImport.update({
    id: '/betaling-instellen',
    path: '/betaling-instellen',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedEnergiefactuurUploadenRouteRoute =
  authenticatedEnergiefactuurUploadenRouteRouteImport.update({
    id: '/energiefactuur-uploaden',
    path: '/energiefactuur-uploaden',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedLaadpaalFotosUploadenRouteRoute =
  authenticatedLaadpaalFotosUploadenRouteRouteImport.update({
    id: '/laadpaal-fotos-uploaden',
    path: '/laadpaal-fotos-uploaden',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedUitbetalingInstellenRouteRoute =
  authenticatedUitbetalingInstellenRouteRouteImport.update({
    id: '/uitbetaling-instellen',
    path: '/uitbetaling-instellen',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedUploadLaadsessiesRouteRoute =
  authenticatedUploadLaadsessiesRouteRouteImport.update({
    id: '/upload-laadsessies',
    path: '/upload-laadsessies',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const authenticatedVerbindAccountRouteRoute =
  authenticatedVerbindAccountRouteRouteImport.update({
    id: '/verbind-account',
    path: '/verbind-account',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)
const publicAccountInactiefRoute = publicAccountInactiefRouteImport.update({
  id: '/account-inactief',
  path: '/account-inactief',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicActievoorwaardenRoute = publicActievoorwaardenRouteImport.update({
  id: '/actievoorwaarden',
  path: '/actievoorwaarden',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicCookiesRoute = publicCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicMachtigingOndertekenenRoute =
  publicMachtigingOndertekenenRouteImport.update({
    id: '/machtiging-ondertekenen',
    path: '/machtiging-ondertekenen',
    getParentRoute: () => publicRouteRoute,
  } as any)
const publicPrivacyRoute = publicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicTermsRoute = publicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => publicRouteRoute,
} as any)
const authPagesOnboardingIndexRoute =
  authPagesOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authPagesOnboardingRouteRoute,
  } as any)
const authPagesOnboardingStepRoute = authPagesOnboardingStepRouteImport.update({
  id: '/$step',
  path: '/$step',
  getParentRoute: () => authPagesOnboardingRouteRoute,
} as any)
const authenticatedBetalingInstellenIndexRoute =
  authenticatedBetalingInstellenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedBetalingInstellenRouteRoute,
  } as any)
const authenticatedBetalingInstellenStepRoute =
  authenticatedBetalingInstellenStepRouteImport.update({
    id: '/$step',
    path: '/$step',
    getParentRoute: () => authenticatedBetalingInstellenRouteRoute,
  } as any)
const authenticatedEnergiefactuurUploadenIndexRoute =
  authenticatedEnergiefactuurUploadenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedEnergiefactuurUploadenRouteRoute,
  } as any)
const authenticatedLaadpaalFotosUploadenIndexRoute =
  authenticatedLaadpaalFotosUploadenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedLaadpaalFotosUploadenRouteRoute,
  } as any)
const authenticatedUitbetalingInstellenIndexRoute =
  authenticatedUitbetalingInstellenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedUitbetalingInstellenRouteRoute,
  } as any)
const authenticatedUploadLaadsessiesIndexRoute =
  authenticatedUploadLaadsessiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedUploadLaadsessiesRouteRoute,
  } as any)
const authenticatedVerbindAccountIndexRoute =
  authenticatedVerbindAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedVerbindAccountRouteRoute,
  } as any)
const publicLaadpaalLocatieTokenRoute =
  publicLaadpaalLocatieTokenRouteImport.update({
    id: '/laadpaal-locatie/$token',
    path: '/laadpaal-locatie/$token',
    getParentRoute: () => publicRouteRoute,
  } as any)
const authenticatedAppDashboardIndexRoute =
  authenticatedAppDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => authenticatedAppRouteRoute,
  } as any)
const authenticatedAppMijnGegevensIndexRoute =
  authenticatedAppMijnGegevensIndexRouteImport.update({
    id: '/mijn-gegevens/',
    path: '/mijn-gegevens/',
    getParentRoute: () => authenticatedAppRouteRoute,
  } as any)
const authenticatedAppMijnLaadpaalIndexRoute =
  authenticatedAppMijnLaadpaalIndexRouteImport.update({
    id: '/mijn-laadpaal/',
    path: '/mijn-laadpaal/',
    getParentRoute: () => authenticatedAppRouteRoute,
  } as any)
const authenticatedAppVriendenvoordeelIndexRoute =
  authenticatedAppVriendenvoordeelIndexRouteImport.update({
    id: '/vriendenvoordeel/',
    path: '/vriendenvoordeel/',
    getParentRoute: () => authenticatedAppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/onboarding': typeof authPagesOnboardingRouteRouteWithChildren
  '/betaling-instellen': typeof authenticatedBetalingInstellenRouteRouteWithChildren
  '/energiefactuur-uploaden': typeof authenticatedEnergiefactuurUploadenRouteRouteWithChildren
  '/laadpaal-fotos-uploaden': typeof authenticatedLaadpaalFotosUploadenRouteRouteWithChildren
  '/uitbetaling-instellen': typeof authenticatedUitbetalingInstellenRouteRouteWithChildren
  '/upload-laadsessies': typeof authenticatedUploadLaadsessiesRouteRouteWithChildren
  '/verbind-account': typeof authenticatedVerbindAccountRouteRouteWithChildren
  '/aanmelden': typeof authPagesAanmeldenRoute
  '/aanmelden-partner': typeof authPagesAanmeldenPartnerRoute
  '/inloggen': typeof authPagesInloggenRoute
  '/verifieren': typeof authPagesVerifierenRoute
  '/account-inactief': typeof publicAccountInactiefRoute
  '/actievoorwaarden': typeof publicActievoorwaardenRoute
  '/cookies': typeof publicCookiesRoute
  '/machtiging-ondertekenen': typeof publicMachtigingOndertekenenRoute
  '/privacy': typeof publicPrivacyRoute
  '/terms': typeof publicTermsRoute
  '/onboarding/$step': typeof authPagesOnboardingStepRoute
  '/betaling-instellen/$step': typeof authenticatedBetalingInstellenStepRoute
  '/laadpaal-locatie/$token': typeof publicLaadpaalLocatieTokenRoute
  '/onboarding/': typeof authPagesOnboardingIndexRoute
  '/betaling-instellen/': typeof authenticatedBetalingInstellenIndexRoute
  '/energiefactuur-uploaden/': typeof authenticatedEnergiefactuurUploadenIndexRoute
  '/laadpaal-fotos-uploaden/': typeof authenticatedLaadpaalFotosUploadenIndexRoute
  '/uitbetaling-instellen/': typeof authenticatedUitbetalingInstellenIndexRoute
  '/upload-laadsessies/': typeof authenticatedUploadLaadsessiesIndexRoute
  '/verbind-account/': typeof authenticatedVerbindAccountIndexRoute
  '/dashboard/': typeof authenticatedAppDashboardIndexRoute
  '/mijn-gegevens/': typeof authenticatedAppMijnGegevensIndexRoute
  '/mijn-laadpaal/': typeof authenticatedAppMijnLaadpaalIndexRoute
  '/vriendenvoordeel/': typeof authenticatedAppVriendenvoordeelIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/aanmelden': typeof authPagesAanmeldenRoute
  '/aanmelden-partner': typeof authPagesAanmeldenPartnerRoute
  '/inloggen': typeof authPagesInloggenRoute
  '/verifieren': typeof authPagesVerifierenRoute
  '/account-inactief': typeof publicAccountInactiefRoute
  '/actievoorwaarden': typeof publicActievoorwaardenRoute
  '/cookies': typeof publicCookiesRoute
  '/machtiging-ondertekenen': typeof publicMachtigingOndertekenenRoute
  '/privacy': typeof publicPrivacyRoute
  '/terms': typeof publicTermsRoute
  '/onboarding/$step': typeof authPagesOnboardingStepRoute
  '/betaling-instellen/$step': typeof authenticatedBetalingInstellenStepRoute
  '/laadpaal-locatie/$token': typeof publicLaadpaalLocatieTokenRoute
  '/onboarding': typeof authPagesOnboardingIndexRoute
  '/betaling-instellen': typeof authenticatedBetalingInstellenIndexRoute
  '/energiefactuur-uploaden': typeof authenticatedEnergiefactuurUploadenIndexRoute
  '/laadpaal-fotos-uploaden': typeof authenticatedLaadpaalFotosUploadenIndexRoute
  '/uitbetaling-instellen': typeof authenticatedUitbetalingInstellenIndexRoute
  '/upload-laadsessies': typeof authenticatedUploadLaadsessiesIndexRoute
  '/verbind-account': typeof authenticatedVerbindAccountIndexRoute
  '/dashboard': typeof authenticatedAppDashboardIndexRoute
  '/mijn-gegevens': typeof authenticatedAppMijnGegevensIndexRoute
  '/mijn-laadpaal': typeof authenticatedAppMijnLaadpaalIndexRoute
  '/vriendenvoordeel': typeof authenticatedAppVriendenvoordeelIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth-pages)': typeof authPagesRouteRouteWithChildren
  '/(authenticated)': typeof authenticatedRouteRouteWithChildren
  '/(public)': typeof publicRouteRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/(auth-pages)/onboarding': typeof authPagesOnboardingRouteRouteWithChildren
  '/(authenticated)/_app': typeof authenticatedAppRouteRouteWithChildren
  '/(authenticated)/betaling-instellen': typeof authenticatedBetalingInstellenRouteRouteWithChildren
  '/(authenticated)/energiefactuur-uploaden': typeof authenticatedEnergiefactuurUploadenRouteRouteWithChildren
  '/(authenticated)/laadpaal-fotos-uploaden': typeof authenticatedLaadpaalFotosUploadenRouteRouteWithChildren
  '/(authenticated)/uitbetaling-instellen': typeof authenticatedUitbetalingInstellenRouteRouteWithChildren
  '/(authenticated)/upload-laadsessies': typeof authenticatedUploadLaadsessiesRouteRouteWithChildren
  '/(authenticated)/verbind-account': typeof authenticatedVerbindAccountRouteRouteWithChildren
  '/(auth-pages)/aanmelden': typeof authPagesAanmeldenRoute
  '/(auth-pages)/aanmelden-partner': typeof authPagesAanmeldenPartnerRoute
  '/(auth-pages)/inloggen': typeof authPagesInloggenRoute
  '/(auth-pages)/verifieren': typeof authPagesVerifierenRoute
  '/(public)/account-inactief': typeof publicAccountInactiefRoute
  '/(public)/actievoorwaarden': typeof publicActievoorwaardenRoute
  '/(public)/cookies': typeof publicCookiesRoute
  '/(public)/machtiging-ondertekenen': typeof publicMachtigingOndertekenenRoute
  '/(public)/privacy': typeof publicPrivacyRoute
  '/(public)/terms': typeof publicTermsRoute
  '/(auth-pages)/onboarding/$step': typeof authPagesOnboardingStepRoute
  '/(authenticated)/betaling-instellen/$step': typeof authenticatedBetalingInstellenStepRoute
  '/(public)/laadpaal-locatie/$token': typeof publicLaadpaalLocatieTokenRoute
  '/(auth-pages)/onboarding/': typeof authPagesOnboardingIndexRoute
  '/(authenticated)/betaling-instellen/': typeof authenticatedBetalingInstellenIndexRoute
  '/(authenticated)/energiefactuur-uploaden/': typeof authenticatedEnergiefactuurUploadenIndexRoute
  '/(authenticated)/laadpaal-fotos-uploaden/': typeof authenticatedLaadpaalFotosUploadenIndexRoute
  '/(authenticated)/uitbetaling-instellen/': typeof authenticatedUitbetalingInstellenIndexRoute
  '/(authenticated)/upload-laadsessies/': typeof authenticatedUploadLaadsessiesIndexRoute
  '/(authenticated)/verbind-account/': typeof authenticatedVerbindAccountIndexRoute
  '/(authenticated)/_app/dashboard/': typeof authenticatedAppDashboardIndexRoute
  '/(authenticated)/_app/mijn-gegevens/': typeof authenticatedAppMijnGegevensIndexRoute
  '/(authenticated)/_app/mijn-laadpaal/': typeof authenticatedAppMijnLaadpaalIndexRoute
  '/(authenticated)/_app/vriendenvoordeel/': typeof authenticatedAppVriendenvoordeelIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/onboarding'
    | '/betaling-instellen'
    | '/energiefactuur-uploaden'
    | '/laadpaal-fotos-uploaden'
    | '/uitbetaling-instellen'
    | '/upload-laadsessies'
    | '/verbind-account'
    | '/aanmelden'
    | '/aanmelden-partner'
    | '/inloggen'
    | '/verifieren'
    | '/account-inactief'
    | '/actievoorwaarden'
    | '/cookies'
    | '/machtiging-ondertekenen'
    | '/privacy'
    | '/terms'
    | '/onboarding/$step'
    | '/betaling-instellen/$step'
    | '/laadpaal-locatie/$token'
    | '/onboarding/'
    | '/betaling-instellen/'
    | '/energiefactuur-uploaden/'
    | '/laadpaal-fotos-uploaden/'
    | '/uitbetaling-instellen/'
    | '/upload-laadsessies/'
    | '/verbind-account/'
    | '/dashboard/'
    | '/mijn-gegevens/'
    | '/mijn-laadpaal/'
    | '/vriendenvoordeel/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/aanmelden'
    | '/aanmelden-partner'
    | '/inloggen'
    | '/verifieren'
    | '/account-inactief'
    | '/actievoorwaarden'
    | '/cookies'
    | '/machtiging-ondertekenen'
    | '/privacy'
    | '/terms'
    | '/onboarding/$step'
    | '/betaling-instellen/$step'
    | '/laadpaal-locatie/$token'
    | '/onboarding'
    | '/betaling-instellen'
    | '/energiefactuur-uploaden'
    | '/laadpaal-fotos-uploaden'
    | '/uitbetaling-instellen'
    | '/upload-laadsessies'
    | '/verbind-account'
    | '/dashboard'
    | '/mijn-gegevens'
    | '/mijn-laadpaal'
    | '/vriendenvoordeel'
  id:
    | '__root__'
    | '/'
    | '/(auth-pages)'
    | '/(authenticated)'
    | '/(public)'
    | '/impersonate'
    | '/(auth-pages)/onboarding'
    | '/(authenticated)/_app'
    | '/(authenticated)/betaling-instellen'
    | '/(authenticated)/energiefactuur-uploaden'
    | '/(authenticated)/laadpaal-fotos-uploaden'
    | '/(authenticated)/uitbetaling-instellen'
    | '/(authenticated)/upload-laadsessies'
    | '/(authenticated)/verbind-account'
    | '/(auth-pages)/aanmelden'
    | '/(auth-pages)/aanmelden-partner'
    | '/(auth-pages)/inloggen'
    | '/(auth-pages)/verifieren'
    | '/(public)/account-inactief'
    | '/(public)/actievoorwaarden'
    | '/(public)/cookies'
    | '/(public)/machtiging-ondertekenen'
    | '/(public)/privacy'
    | '/(public)/terms'
    | '/(auth-pages)/onboarding/$step'
    | '/(authenticated)/betaling-instellen/$step'
    | '/(public)/laadpaal-locatie/$token'
    | '/(auth-pages)/onboarding/'
    | '/(authenticated)/betaling-instellen/'
    | '/(authenticated)/energiefactuur-uploaden/'
    | '/(authenticated)/laadpaal-fotos-uploaden/'
    | '/(authenticated)/uitbetaling-instellen/'
    | '/(authenticated)/upload-laadsessies/'
    | '/(authenticated)/verbind-account/'
    | '/(authenticated)/_app/dashboard/'
    | '/(authenticated)/_app/mijn-gegevens/'
    | '/(authenticated)/_app/mijn-laadpaal/'
    | '/(authenticated)/_app/vriendenvoordeel/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authPagesRouteRoute: typeof authPagesRouteRouteWithChildren
  authenticatedRouteRoute: typeof authenticatedRouteRouteWithChildren
  publicRouteRoute: typeof publicRouteRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth-pages)': {
      id: '/(auth-pages)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authPagesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authenticated)': {
      id: '/(authenticated)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth-pages)/aanmelden': {
      id: '/(auth-pages)/aanmelden'
      path: '/aanmelden'
      fullPath: '/aanmelden'
      preLoaderRoute: typeof authPagesAanmeldenRouteImport
      parentRoute: typeof authPagesRouteRoute
    }
    '/(auth-pages)/aanmelden-partner': {
      id: '/(auth-pages)/aanmelden-partner'
      path: '/aanmelden-partner'
      fullPath: '/aanmelden-partner'
      preLoaderRoute: typeof authPagesAanmeldenPartnerRouteImport
      parentRoute: typeof authPagesRouteRoute
    }
    '/(auth-pages)/inloggen': {
      id: '/(auth-pages)/inloggen'
      path: '/inloggen'
      fullPath: '/inloggen'
      preLoaderRoute: typeof authPagesInloggenRouteImport
      parentRoute: typeof authPagesRouteRoute
    }
    '/(auth-pages)/onboarding': {
      id: '/(auth-pages)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof authPagesOnboardingRouteRouteImport
      parentRoute: typeof authPagesRouteRoute
    }
    '/(auth-pages)/verifieren': {
      id: '/(auth-pages)/verifieren'
      path: '/verifieren'
      fullPath: '/verifieren'
      preLoaderRoute: typeof authPagesVerifierenRouteImport
      parentRoute: typeof authPagesRouteRoute
    }
    '/(authenticated)/_app': {
      id: '/(authenticated)/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authenticatedAppRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/betaling-instellen': {
      id: '/(authenticated)/betaling-instellen'
      path: '/betaling-instellen'
      fullPath: '/betaling-instellen'
      preLoaderRoute: typeof authenticatedBetalingInstellenRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/energiefactuur-uploaden': {
      id: '/(authenticated)/energiefactuur-uploaden'
      path: '/energiefactuur-uploaden'
      fullPath: '/energiefactuur-uploaden'
      preLoaderRoute: typeof authenticatedEnergiefactuurUploadenRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/laadpaal-fotos-uploaden': {
      id: '/(authenticated)/laadpaal-fotos-uploaden'
      path: '/laadpaal-fotos-uploaden'
      fullPath: '/laadpaal-fotos-uploaden'
      preLoaderRoute: typeof authenticatedLaadpaalFotosUploadenRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/uitbetaling-instellen': {
      id: '/(authenticated)/uitbetaling-instellen'
      path: '/uitbetaling-instellen'
      fullPath: '/uitbetaling-instellen'
      preLoaderRoute: typeof authenticatedUitbetalingInstellenRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/upload-laadsessies': {
      id: '/(authenticated)/upload-laadsessies'
      path: '/upload-laadsessies'
      fullPath: '/upload-laadsessies'
      preLoaderRoute: typeof authenticatedUploadLaadsessiesRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(authenticated)/verbind-account': {
      id: '/(authenticated)/verbind-account'
      path: '/verbind-account'
      fullPath: '/verbind-account'
      preLoaderRoute: typeof authenticatedVerbindAccountRouteRouteImport
      parentRoute: typeof authenticatedRouteRoute
    }
    '/(public)/account-inactief': {
      id: '/(public)/account-inactief'
      path: '/account-inactief'
      fullPath: '/account-inactief'
      preLoaderRoute: typeof publicAccountInactiefRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/actievoorwaarden': {
      id: '/(public)/actievoorwaarden'
      path: '/actievoorwaarden'
      fullPath: '/actievoorwaarden'
      preLoaderRoute: typeof publicActievoorwaardenRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/cookies': {
      id: '/(public)/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof publicCookiesRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/machtiging-ondertekenen': {
      id: '/(public)/machtiging-ondertekenen'
      path: '/machtiging-ondertekenen'
      fullPath: '/machtiging-ondertekenen'
      preLoaderRoute: typeof publicMachtigingOndertekenenRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/privacy': {
      id: '/(public)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof publicPrivacyRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/terms': {
      id: '/(public)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof publicTermsRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(auth-pages)/onboarding/': {
      id: '/(auth-pages)/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof authPagesOnboardingIndexRouteImport
      parentRoute: typeof authPagesOnboardingRouteRoute
    }
    '/(auth-pages)/onboarding/$step': {
      id: '/(auth-pages)/onboarding/$step'
      path: '/$step'
      fullPath: '/onboarding/$step'
      preLoaderRoute: typeof authPagesOnboardingStepRouteImport
      parentRoute: typeof authPagesOnboardingRouteRoute
    }
    '/(authenticated)/betaling-instellen/': {
      id: '/(authenticated)/betaling-instellen/'
      path: '/'
      fullPath: '/betaling-instellen/'
      preLoaderRoute: typeof authenticatedBetalingInstellenIndexRouteImport
      parentRoute: typeof authenticatedBetalingInstellenRouteRoute
    }
    '/(authenticated)/betaling-instellen/$step': {
      id: '/(authenticated)/betaling-instellen/$step'
      path: '/$step'
      fullPath: '/betaling-instellen/$step'
      preLoaderRoute: typeof authenticatedBetalingInstellenStepRouteImport
      parentRoute: typeof authenticatedBetalingInstellenRouteRoute
    }
    '/(authenticated)/energiefactuur-uploaden/': {
      id: '/(authenticated)/energiefactuur-uploaden/'
      path: '/'
      fullPath: '/energiefactuur-uploaden/'
      preLoaderRoute: typeof authenticatedEnergiefactuurUploadenIndexRouteImport
      parentRoute: typeof authenticatedEnergiefactuurUploadenRouteRoute
    }
    '/(authenticated)/laadpaal-fotos-uploaden/': {
      id: '/(authenticated)/laadpaal-fotos-uploaden/'
      path: '/'
      fullPath: '/laadpaal-fotos-uploaden/'
      preLoaderRoute: typeof authenticatedLaadpaalFotosUploadenIndexRouteImport
      parentRoute: typeof authenticatedLaadpaalFotosUploadenRouteRoute
    }
    '/(authenticated)/uitbetaling-instellen/': {
      id: '/(authenticated)/uitbetaling-instellen/'
      path: '/'
      fullPath: '/uitbetaling-instellen/'
      preLoaderRoute: typeof authenticatedUitbetalingInstellenIndexRouteImport
      parentRoute: typeof authenticatedUitbetalingInstellenRouteRoute
    }
    '/(authenticated)/upload-laadsessies/': {
      id: '/(authenticated)/upload-laadsessies/'
      path: '/'
      fullPath: '/upload-laadsessies/'
      preLoaderRoute: typeof authenticatedUploadLaadsessiesIndexRouteImport
      parentRoute: typeof authenticatedUploadLaadsessiesRouteRoute
    }
    '/(authenticated)/verbind-account/': {
      id: '/(authenticated)/verbind-account/'
      path: '/'
      fullPath: '/verbind-account/'
      preLoaderRoute: typeof authenticatedVerbindAccountIndexRouteImport
      parentRoute: typeof authenticatedVerbindAccountRouteRoute
    }
    '/(public)/laadpaal-locatie/$token': {
      id: '/(public)/laadpaal-locatie/$token'
      path: '/laadpaal-locatie/$token'
      fullPath: '/laadpaal-locatie/$token'
      preLoaderRoute: typeof publicLaadpaalLocatieTokenRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(authenticated)/_app/dashboard/': {
      id: '/(authenticated)/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof authenticatedAppDashboardIndexRouteImport
      parentRoute: typeof authenticatedAppRouteRoute
    }
    '/(authenticated)/_app/mijn-gegevens/': {
      id: '/(authenticated)/_app/mijn-gegevens/'
      path: '/mijn-gegevens'
      fullPath: '/mijn-gegevens/'
      preLoaderRoute: typeof authenticatedAppMijnGegevensIndexRouteImport
      parentRoute: typeof authenticatedAppRouteRoute
    }
    '/(authenticated)/_app/mijn-laadpaal/': {
      id: '/(authenticated)/_app/mijn-laadpaal/'
      path: '/mijn-laadpaal'
      fullPath: '/mijn-laadpaal/'
      preLoaderRoute: typeof authenticatedAppMijnLaadpaalIndexRouteImport
      parentRoute: typeof authenticatedAppRouteRoute
    }
    '/(authenticated)/_app/vriendenvoordeel/': {
      id: '/(authenticated)/_app/vriendenvoordeel/'
      path: '/vriendenvoordeel'
      fullPath: '/vriendenvoordeel/'
      preLoaderRoute: typeof authenticatedAppVriendenvoordeelIndexRouteImport
      parentRoute: typeof authenticatedAppRouteRoute
    }
  }
}

interface authPagesOnboardingRouteRouteChildren {
  authPagesOnboardingStepRoute: typeof authPagesOnboardingStepRoute
  authPagesOnboardingIndexRoute: typeof authPagesOnboardingIndexRoute
}

const authPagesOnboardingRouteRouteChildren: authPagesOnboardingRouteRouteChildren =
  {
    authPagesOnboardingStepRoute: authPagesOnboardingStepRoute,
    authPagesOnboardingIndexRoute: authPagesOnboardingIndexRoute,
  }

const authPagesOnboardingRouteRouteWithChildren =
  authPagesOnboardingRouteRoute._addFileChildren(
    authPagesOnboardingRouteRouteChildren,
  )

interface authPagesRouteRouteChildren {
  authPagesOnboardingRouteRoute: typeof authPagesOnboardingRouteRouteWithChildren
  authPagesAanmeldenRoute: typeof authPagesAanmeldenRoute
  authPagesAanmeldenPartnerRoute: typeof authPagesAanmeldenPartnerRoute
  authPagesInloggenRoute: typeof authPagesInloggenRoute
  authPagesVerifierenRoute: typeof authPagesVerifierenRoute
}

const authPagesRouteRouteChildren: authPagesRouteRouteChildren = {
  authPagesOnboardingRouteRoute: authPagesOnboardingRouteRouteWithChildren,
  authPagesAanmeldenRoute: authPagesAanmeldenRoute,
  authPagesAanmeldenPartnerRoute: authPagesAanmeldenPartnerRoute,
  authPagesInloggenRoute: authPagesInloggenRoute,
  authPagesVerifierenRoute: authPagesVerifierenRoute,
}

const authPagesRouteRouteWithChildren = authPagesRouteRoute._addFileChildren(
  authPagesRouteRouteChildren,
)

interface authenticatedAppRouteRouteChildren {
  authenticatedAppDashboardIndexRoute: typeof authenticatedAppDashboardIndexRoute
  authenticatedAppMijnGegevensIndexRoute: typeof authenticatedAppMijnGegevensIndexRoute
  authenticatedAppMijnLaadpaalIndexRoute: typeof authenticatedAppMijnLaadpaalIndexRoute
  authenticatedAppVriendenvoordeelIndexRoute: typeof authenticatedAppVriendenvoordeelIndexRoute
}

const authenticatedAppRouteRouteChildren: authenticatedAppRouteRouteChildren = {
  authenticatedAppDashboardIndexRoute: authenticatedAppDashboardIndexRoute,
  authenticatedAppMijnGegevensIndexRoute:
    authenticatedAppMijnGegevensIndexRoute,
  authenticatedAppMijnLaadpaalIndexRoute:
    authenticatedAppMijnLaadpaalIndexRoute,
  authenticatedAppVriendenvoordeelIndexRoute:
    authenticatedAppVriendenvoordeelIndexRoute,
}

const authenticatedAppRouteRouteWithChildren =
  authenticatedAppRouteRoute._addFileChildren(
    authenticatedAppRouteRouteChildren,
  )

interface authenticatedBetalingInstellenRouteRouteChildren {
  authenticatedBetalingInstellenStepRoute: typeof authenticatedBetalingInstellenStepRoute
  authenticatedBetalingInstellenIndexRoute: typeof authenticatedBetalingInstellenIndexRoute
}

const authenticatedBetalingInstellenRouteRouteChildren: authenticatedBetalingInstellenRouteRouteChildren =
  {
    authenticatedBetalingInstellenStepRoute:
      authenticatedBetalingInstellenStepRoute,
    authenticatedBetalingInstellenIndexRoute:
      authenticatedBetalingInstellenIndexRoute,
  }

const authenticatedBetalingInstellenRouteRouteWithChildren =
  authenticatedBetalingInstellenRouteRoute._addFileChildren(
    authenticatedBetalingInstellenRouteRouteChildren,
  )

interface authenticatedEnergiefactuurUploadenRouteRouteChildren {
  authenticatedEnergiefactuurUploadenIndexRoute: typeof authenticatedEnergiefactuurUploadenIndexRoute
}

const authenticatedEnergiefactuurUploadenRouteRouteChildren: authenticatedEnergiefactuurUploadenRouteRouteChildren =
  {
    authenticatedEnergiefactuurUploadenIndexRoute:
      authenticatedEnergiefactuurUploadenIndexRoute,
  }

const authenticatedEnergiefactuurUploadenRouteRouteWithChildren =
  authenticatedEnergiefactuurUploadenRouteRoute._addFileChildren(
    authenticatedEnergiefactuurUploadenRouteRouteChildren,
  )

interface authenticatedLaadpaalFotosUploadenRouteRouteChildren {
  authenticatedLaadpaalFotosUploadenIndexRoute: typeof authenticatedLaadpaalFotosUploadenIndexRoute
}

const authenticatedLaadpaalFotosUploadenRouteRouteChildren: authenticatedLaadpaalFotosUploadenRouteRouteChildren =
  {
    authenticatedLaadpaalFotosUploadenIndexRoute:
      authenticatedLaadpaalFotosUploadenIndexRoute,
  }

const authenticatedLaadpaalFotosUploadenRouteRouteWithChildren =
  authenticatedLaadpaalFotosUploadenRouteRoute._addFileChildren(
    authenticatedLaadpaalFotosUploadenRouteRouteChildren,
  )

interface authenticatedUitbetalingInstellenRouteRouteChildren {
  authenticatedUitbetalingInstellenIndexRoute: typeof authenticatedUitbetalingInstellenIndexRoute
}

const authenticatedUitbetalingInstellenRouteRouteChildren: authenticatedUitbetalingInstellenRouteRouteChildren =
  {
    authenticatedUitbetalingInstellenIndexRoute:
      authenticatedUitbetalingInstellenIndexRoute,
  }

const authenticatedUitbetalingInstellenRouteRouteWithChildren =
  authenticatedUitbetalingInstellenRouteRoute._addFileChildren(
    authenticatedUitbetalingInstellenRouteRouteChildren,
  )

interface authenticatedUploadLaadsessiesRouteRouteChildren {
  authenticatedUploadLaadsessiesIndexRoute: typeof authenticatedUploadLaadsessiesIndexRoute
}

const authenticatedUploadLaadsessiesRouteRouteChildren: authenticatedUploadLaadsessiesRouteRouteChildren =
  {
    authenticatedUploadLaadsessiesIndexRoute:
      authenticatedUploadLaadsessiesIndexRoute,
  }

const authenticatedUploadLaadsessiesRouteRouteWithChildren =
  authenticatedUploadLaadsessiesRouteRoute._addFileChildren(
    authenticatedUploadLaadsessiesRouteRouteChildren,
  )

interface authenticatedVerbindAccountRouteRouteChildren {
  authenticatedVerbindAccountIndexRoute: typeof authenticatedVerbindAccountIndexRoute
}

const authenticatedVerbindAccountRouteRouteChildren: authenticatedVerbindAccountRouteRouteChildren =
  {
    authenticatedVerbindAccountIndexRoute:
      authenticatedVerbindAccountIndexRoute,
  }

const authenticatedVerbindAccountRouteRouteWithChildren =
  authenticatedVerbindAccountRouteRoute._addFileChildren(
    authenticatedVerbindAccountRouteRouteChildren,
  )

interface authenticatedRouteRouteChildren {
  authenticatedAppRouteRoute: typeof authenticatedAppRouteRouteWithChildren
  authenticatedBetalingInstellenRouteRoute: typeof authenticatedBetalingInstellenRouteRouteWithChildren
  authenticatedEnergiefactuurUploadenRouteRoute: typeof authenticatedEnergiefactuurUploadenRouteRouteWithChildren
  authenticatedLaadpaalFotosUploadenRouteRoute: typeof authenticatedLaadpaalFotosUploadenRouteRouteWithChildren
  authenticatedUitbetalingInstellenRouteRoute: typeof authenticatedUitbetalingInstellenRouteRouteWithChildren
  authenticatedUploadLaadsessiesRouteRoute: typeof authenticatedUploadLaadsessiesRouteRouteWithChildren
  authenticatedVerbindAccountRouteRoute: typeof authenticatedVerbindAccountRouteRouteWithChildren
}

const authenticatedRouteRouteChildren: authenticatedRouteRouteChildren = {
  authenticatedAppRouteRoute: authenticatedAppRouteRouteWithChildren,
  authenticatedBetalingInstellenRouteRoute:
    authenticatedBetalingInstellenRouteRouteWithChildren,
  authenticatedEnergiefactuurUploadenRouteRoute:
    authenticatedEnergiefactuurUploadenRouteRouteWithChildren,
  authenticatedLaadpaalFotosUploadenRouteRoute:
    authenticatedLaadpaalFotosUploadenRouteRouteWithChildren,
  authenticatedUitbetalingInstellenRouteRoute:
    authenticatedUitbetalingInstellenRouteRouteWithChildren,
  authenticatedUploadLaadsessiesRouteRoute:
    authenticatedUploadLaadsessiesRouteRouteWithChildren,
  authenticatedVerbindAccountRouteRoute:
    authenticatedVerbindAccountRouteRouteWithChildren,
}

const authenticatedRouteRouteWithChildren =
  authenticatedRouteRoute._addFileChildren(authenticatedRouteRouteChildren)

interface publicRouteRouteChildren {
  publicAccountInactiefRoute: typeof publicAccountInactiefRoute
  publicActievoorwaardenRoute: typeof publicActievoorwaardenRoute
  publicCookiesRoute: typeof publicCookiesRoute
  publicMachtigingOndertekenenRoute: typeof publicMachtigingOndertekenenRoute
  publicPrivacyRoute: typeof publicPrivacyRoute
  publicTermsRoute: typeof publicTermsRoute
  publicLaadpaalLocatieTokenRoute: typeof publicLaadpaalLocatieTokenRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicAccountInactiefRoute: publicAccountInactiefRoute,
  publicActievoorwaardenRoute: publicActievoorwaardenRoute,
  publicCookiesRoute: publicCookiesRoute,
  publicMachtigingOndertekenenRoute: publicMachtigingOndertekenenRoute,
  publicPrivacyRoute: publicPrivacyRoute,
  publicTermsRoute: publicTermsRoute,
  publicLaadpaalLocatieTokenRoute: publicLaadpaalLocatieTokenRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authPagesRouteRoute: authPagesRouteRouteWithChildren,
  authenticatedRouteRoute: authenticatedRouteRouteWithChildren,
  publicRouteRoute: publicRouteRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
